export const CHAT_LOADING="app/chat/CHAT_LOADING"
